class ScrollToTopButton {
  constructor(button) {
    this.button = button;
    this.isRevealed = false;
    this.onScrollHandler = this.onScroll.bind(this);
    this.onClickHandler = this.scrollToTop.bind(this);
    this.onKeyDownHandler = this.onKeyDown.bind(this);

    this.updateVisibility();
    window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    this.button.addEventListener('click', this.onClickHandler);
    this.button.addEventListener('keydown', this.onKeyDownHandler);
  }

  onScroll() {
    if (this._ticking) return;
    this._ticking = true;

    requestAnimationFrame(() => {
      this._ticking = false;
      this.updateVisibility();
    });
  }

  updateVisibility() {
    const shouldReveal = window.scrollY > window.innerHeight;
    if (shouldReveal !== this.isRevealed) {
      this.isRevealed = shouldReveal;
      this.button.classList.toggle('reveal', shouldReveal);
    }
  }

  scrollToTop() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' });

    const focusDelay = prefersReducedMotion ? 0 : 700;
    setTimeout(() => {
      document.querySelector('.skip-to-content-link')?.focus();
    }, focusDelay);
  }

  onKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.scrollToTop();
    }
  }
}

function initScrollToTopButtons(root = document) {
  root.querySelectorAll('.scroll-to-top-button:not([data-scroll-to-top-init])').forEach((button) => {
    button.dataset.scrollToTopInit = 'true';
    new ScrollToTopButton(button);
  });
}

window.addEventListener('DOMContentLoaded', () => initScrollToTopButtons());

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initScrollToTopButtons(event.target));
}
